/**
 * Resolve the "entry" initial root-item code for the widget from its host-facing inputs.
 *
 * Two ways a host can point the widget at a starting model:
 *  - `initial-item="<code>"` — a static choice baked into the embed.
 *  - `initial-item-param="<name>"` — the name of a URL query param (e.g. `model`) that the widget
 *    reads from `location.search` at load, so a deep link like `/configurator?model=<code>` opens
 *    the widget on that model. This is the widget's own URL reading — hosts declare intent via the
 *    attribute; they never have to script the URL themselves.
 *
 * The explicit attribute wins when present; otherwise the named query param is read. A declared
 * param that is absent (or empty) in the URL yields `undefined` — a plain visit with no deep link.
 * The query is NEVER read unless a param name is declared, so the widget can't accidentally hijack
 * an unrelated `?model=` a host page uses for its own purposes.
 *
 * NB: this resolves only the ENTRY hint. The widget's own saved/shared state hash (`#m=…`) is
 * authoritative over it — that precedence lives at the point of use (see state/context.tsx), not here.
 */
export function readEntryInitialItem(
  initialItemAttr: string | null,
  initialItemParamAttr: string | null,
  search: string,
): string | undefined {
  if (initialItemAttr) return initialItemAttr;
  if (!initialItemParamAttr) return undefined;
  const value = new URLSearchParams(search).get(initialItemParamAttr);
  return value || undefined;
}
